<div class="ui padded grid">
  <div class="row">
    <div class="two wide column">
      <!--SIDEBAR-->
      <div class="ui vertical fluid tabular menu">
        <a class="item" routerLink="articles" [routerLinkActive]="['active']" i18n="@@articles">Artikel</a>
        <a class="item" routerLink="internalMessages" [routerLinkActive]="['active']" i18n="@@internal-messages">Interne Mitteilungen</a>
        <a class="item" href="https://goto.uni-kassel.de/go/fit-anleitung-artikelerstellung" target="_blank">
          <ng-container i18n="@@manual">Anleitung</ng-container>
          <i class="external icon"></i>
        </a>
      </div>
    </div>
    <div class="fourteen wide stretched column">
      <div class="ui segment">
        <!--CONTENT-->
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

